import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { cloneDeep, get } from "lodash";
import Amplitude from "../amplitude";
export const hasApplicationValue = actualValue => actualValue != undefined && actualValue !== "";
export const applicationHasCoApplicants = applicationObject => {
  const mainApplicant = get(applicationObject, "main-applicant");
  return get(mainApplicant, "[personal-details][coapp]");
};

/**
 * Make a Copy of the current application object
 * and run all the transforms passed as param
 * the result of each transform will be passed to the next transform
 */
export const runSafeApplicationTransform = (...callbacks) => applicationObject => {
  try {
    return _reduceInstanceProperty(callbacks).call(callbacks, (acc, callback) => {
      acc = callback(acc);
      return acc;
    }, cloneDeep(applicationObject));
  } catch (error) {
    Amplitude.logHandledError(error);
    return applicationObject; //if something goes wrong just return the initial object
  }
};